import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings/alpha';

export const userSettingsFr = createTranslationMessages({
  ref: userSettingsTranslationRef,
  full: true,
  messages: {
    'featureFlags.title': 'Feature Flags',
    'featureFlags.description':
      'Veuillez actualiser la page après avoir activé ou désactivé des feature flags',
    'featureFlags.filterTitle': 'Filtrer',
    'featureFlags.clearFilter': 'Effacer le filtre',
    'featureFlags.emptyFlags.title': 'Aucun feature flag',
    'featureFlags.emptyFlags.action.title':
      'Un exemple d’ajout de feature flag est mis en évidence ci-dessous :',
    'featureFlags.emptyFlags.action.readMoreButtonTitle': 'En savoir plus',
    'featureFlags.emptyFlags.description':
      'Les feature flags permettent aux plugins d’enregistrer des fonctionnalités dans Backstage auxquelles les utilisateurs peuvent adhérer. Vous pouvez les utiliser pour séparer la logique de votre code, par exemple pour des tests A/B manuels.',
    'featureFlags.flagItem.title.disable': 'Désactiver',
    'featureFlags.flagItem.title.enable': 'Activer',
    'featureFlags.flagItem.subtitle.registeredInApplication':
      'Enregistré dans l’application',
    'featureFlags.flagItem.subtitle.registeredInPlugin':
      'Enregistré dans le plugin {{pluginId}}',
    'languageToggle.select': 'Sélectionner la langue {{language}}',
    'languageToggle.title': 'Langue',
    'languageToggle.description': 'Changer la langue',
    'themeToggle.select': 'Sélectionner {{theme}}',
    'themeToggle.title': 'Thème',
    'themeToggle.description': 'Changer le mode du thème',
    'themeToggle.names.auto': 'Auto',
    'themeToggle.names.dark': 'Sombre',
    'themeToggle.names.light': 'Clair',
    'themeToggle.selectAuto': 'Sélectionner le thème automatique',
    'signOutMenu.title': 'Se déconnecter',
    'signOutMenu.moreIconTitle': 'plus',
    'pinToggle.title': 'Épingler la barre latérale',
    'pinToggle.description': 'Empêcher la barre latérale de se replier',
    'pinToggle.ariaLabelTitle': 'Interrupteur d’épinglage de la barre latérale',
    'pinToggle.switchTitles.unpin': 'Détacher la barre latérale',
    'pinToggle.switchTitles.pin': 'Épingler la barre latérale',
    'identityCard.title': 'Identité Backstage',
    'identityCard.noIdentityTitle': 'Aucune identité Backstage',
    'identityCard.userEntity': 'Entité utilisateur',
    'identityCard.ownershipEntities': 'Entités possédées',
    'defaultProviderSettings.description':
      'Fournit l’authentification auprès des API et identités {{provider}}',
    'emptyProviders.title': 'Aucun fournisseur d’authentification',
    'emptyProviders.action.title':
      'Ouvrez app-config.yaml et effectuez les modifications mises en évidence ci-dessous :',
    'emptyProviders.action.readMoreButtonTitle': 'En savoir plus',
    'emptyProviders.description':
      'Vous pouvez ajouter des fournisseurs d’authentification à Backstage, ce qui vous permet de les utiliser pour vous authentifier.',
    'providerSettingsItem.title.signIn': 'Se connecter à {{title}}',
    'providerSettingsItem.title.signOut': 'Se déconnecter de {{title}}',
    'providerSettingsItem.buttonTitle.signIn': 'Se connecter',
    'providerSettingsItem.buttonTitle.signOut': 'Se déconnecter',
    'authProviders.title': 'Fournisseurs disponibles',
    'defaultSettingsPage.tabsTitle.featureFlags': 'Feature Flags',
    'defaultSettingsPage.tabsTitle.authProviders':
      'Fournisseurs d’authentification',
    'defaultSettingsPage.tabsTitle.general': 'Général',
    'settingsLayout.title': 'Paramètres',
    sidebarTitle: 'Paramètres',
    'profileCard.title': 'Profil',
    'appearanceCard.title': 'Apparence',
  },
});
